import { navigate } from '@reach/router'
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { Outline, Primary } from '@cinch/oxd-components/button/src'
import { actions as authActions } from '@cinch/oxd-redux/auth/src'

import * as styles from './auth-buttons.module.css'

interface PropsFromState {
  isAuthenticated: boolean
}

interface PropsFromDispatch {
  handleLogin: () => Dispatch
  handleLogout: () => Dispatch
  handleRegister: () => any
}

export const mapStateToProps = (state: any): PropsFromState => ({
  isAuthenticated: !!(state.oidc && state.oidc.user),
})

export const mapDispatchToProps = (dispatch: any): PropsFromDispatch => ({
  handleLogin: () => dispatch(authActions.login()),
  handleLogout: () => dispatch(authActions.logout()),
  handleRegister: () => {
    dispatch(authActions.register())
    navigate('/sign-up')
  },
})

const Component: React.FC<{
  isAuthenticated: boolean
  handleLogin: () => void
  handleLogout: () => void
  handleRegister: () => void
}> = ({ isAuthenticated = false, handleLogin, handleLogout, handleRegister }) => {
  const Anon = () => (
    <div className={styles.actions}>
      <Outline isFullWidth={true} className={styles.buttons} onClick={handleLogin} size={'mini'}>
        Log in
      </Outline>
      <Primary isFullWidth={true} oxdClassName={styles.buttons} onClick={handleRegister} size={'mini'} oxford={true}>
        Register
      </Primary>
    </div>
  )
  const Authed = () => (
    <Outline isFullWidth={true} onClick={handleLogout}>
      Log out
    </Outline>
  )

  return isAuthenticated ? <Authed /> : <Anon />
}

export default connect<PropsFromState, PropsFromDispatch, any, any>(mapStateToProps, mapDispatchToProps)(Component)
